import { IError } from '@checkout/errors';

export function logger(error: IError) {
  let errorMessage = null;
  let message = null;

  if (error.response && error.response.data) {
    // API responded with a status code that falls out of the range of 2xx
    message = error.response.data;
  } else {
    // Something happened in setting up the request that triggered an Error
    errorMessage = error;
  }

  if (errorMessage) {
    // tslint:disable-next-line:no-console
    console.error('logger/errorMessage:', errorMessage);
  }
  if (message) {
    // tslint:disable-next-line:no-console
    // console.log('logger/message:', message);
  }
  // TODO: think about bugsnag here
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/logger.ts